import type { ErrorCode } from './codes';
import type { ApiError } from './types';

export const TR_MESSAGES = {
  // Generic
  ABOUT_BLANK: 'Beklenmeyen bir hata oluştu.',
  VALIDATION_FAILED: 'Lütfen form alanlarını kontrol edin.',
  UNAUTHORIZED: 'Oturumunuz doğrulanamadı. Lütfen tekrar giriş yapın.',
  FORBIDDEN: 'Bu işlem için yetkiniz yok.',
  INTERNAL_ERROR: 'Sunucu hatası. Lütfen tekrar deneyin.',
  // Domain
  PROJECT_NOT_FOUND: 'Proje bulunamadı.',
  TASK_NOT_FOUND: 'Görev bulunamadı.',
  TICKET_NOT_FOUND: 'Talep bulunamadı.',
  CUSTOMER_NOT_FOUND: 'Müşteri bulunamadı.',
  CUSTOMER_CONTACT_NOT_FOUND: 'Müşteri kişisi bulunamadı.',
  TENANT_REQUIRED: 'Tenant bilgisi gerekli. Lütfen tekrar giriş yapın.',
  TENANT_NOT_FOUND: 'Şirket bulunamadı.',
  TENANT_ACCESS_DENIED: 'Bu şirkete erişim yetkiniz yok.',
  USER_NOT_FOUND: 'Kullanıcı bulunamadı.',
  DUPLICATE_EMAIL: 'Bu e-posta zaten kullanımda.',
  DUPLICATE_DOMAIN: 'Bu domain zaten kullanımda.',
  SUBSCRIPTION_EXPIRED: 'Aboneliğiniz sona ermiş. Lütfen yenileyin.',
  INVALID_CREDENTIALS: 'E-posta veya şifre hatalı.',
  TOKEN_EXPIRED: 'Oturum süresi doldu. Lütfen tekrar giriş yapın.',
  RATE_LIMIT_EXCEEDED: 'Çok fazla istek gönderdiniz. Lütfen biraz bekleyin.',
  FILE_TYPE_NOT_ALLOWED: 'Bu dosya türüne izin verilmiyor.',
  FILE_TOO_LARGE: 'Dosya boyutu çok büyük.',
  BUSINESS_RULE_VIOLATION: 'Bu işlem iş kurallarına uygun değil.',
  RESOURCE_NOT_FOUND: 'Kayıt bulunamadı.',
  RESOURCE_CONFLICT: 'Bu kayıt zaten mevcut.',
} as const satisfies Record<ErrorCode, string>;

export function resolveMessage(err: ApiError): string {
  const mapped = TR_MESSAGES[err.code as ErrorCode];
  if (mapped) return mapped;
  if (err.title) return err.title;
  return 'Bir hata oluştu';
}
